import UserWithNoActiveOrders from './UserWithNoActiveOrders';

export default UserWithNoActiveOrders;
